import React from 'react';

export default function InvalidYear() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <h1 className="text-4xl font-bold text-gray-800 mb-4 text-center">Unfortunately, we didn't make a Holiday Card this year.</h1>
      {/* TODO: Check out our other holiday cards button */}
      {/* TODO: Home button */}
      </div>
  );
}
